import React from "react";
import { Box, Button, Stack } from "@mui/joy";

interface UploadActionButtonsProps {
  isUploading: boolean;
  recordedVideo: Blob | null;
  onUpload: () => void;
  onRedo: () => void;
}

export const UploadActionButtons: React.FC<UploadActionButtonsProps> = ({
  isUploading,
  recordedVideo,
  onUpload,
  onRedo,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        sx={{
          pb: 4,
          width: "100%",
          maxWidth: { sm: 400, lg: 600, xl: 650 },
          mx: "auto",
        }}
      >
        <Button
          type="submit"
          variant="solid"
          onClick={onUpload}
          loading={isUploading}
          disabled={isUploading || !recordedVideo}
          fullWidth
          sx={{
            py: { xs: 1, md: 1.5 },
          }}
        >
          Upload
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={onRedo}
          fullWidth
          size="lg"
          sx={{
            backgroundColor: "background.body",
            borderColor: "#2e2d7e",
            color: "#2e2d7e",
            fontSize: { xs: "md", md: "lg" },
            py: { xs: 1, md: 1.5 },
            "&:hover": {
              backgroundColor: "background.level1",
              borderColor: "#2e2d7e",
              color: "#2e2d7e",
            },
          }}
          disabled={isUploading || !recordedVideo}
        >
          Redo
        </Button>
      </Stack>
    </Box>
  );
};
